"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncFind = void 0;
/**
 * Find an the first item in the array that satisfies the predicate.
 *
 * @param array     Array of elements
 * @param predicate Asynchronous predicate function to test each item in the array.
 * @returns
 */
function asyncFind(array, predicate) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = array.map(predicate);
        const results = yield Promise.all(promises);
        const index = results.findIndex((result) => result);
        return array[index];
    });
}
exports.asyncFind = asyncFind;
